import * as React from "react";
import { SVGProps } from "react";

const ClosedEye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M4.5 15.5c3-6.5 12-6.5 15 0M16.816 12.182 19.5 8.5M12 10.625V7M7.184 12.182 4.5 8.5" />
    </g>
  </svg>
);
export default ClosedEye;
